import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "@fontsource/nunito/400.css"; // Regular
import "@fontsource/nunito/700.css"; // Bold

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";
import config from "./config";
import { Provider } from "react-redux";
import { store } from "src/store/store";
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    {/* error-fallback add pending */}
    <BrowserRouter basename={config.basename}>
      <App />
    </BrowserRouter>
  </Provider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
